import React from 'react';

export const ContentLeftImage = () => {
  return (
    <div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/content/contents-left.jpeg")`}}></div>
  );
};